import { AgreementDetails } from "features/types";
import { useQuery } from "@tanstack/react-query";
import { get } from "services/http";

export type AgreementVisibility = "REGISTRATION" | "LOGIN" | "ACCOUNT_PAGE";

export const useFetchAgreementsQuery = (visibility: AgreementVisibility) => {
  return useQuery(
    ["fetchAgreements", visibility],
    () => {
      return get({
        url: `/agreements/find/${visibility}`,
      }) as Promise<Array<AgreementDetails>>;
    },
    {
      staleTime: Infinity,
    }
  );
};
